import { functionFrom, FunctionLibrary, getFunctionSignature } from '../FunctionDefinition';
import { TYPES } from '../Types';

const loanHasPaymentDeferral = functionFrom(
  'loanHasPaymentDeferral',
  [] as const,
  TYPES.boolean,
  (_ctx) => false, // TODO
  'Indicates whether the loan currently has a payment deferral in effect (stub implementation).',
);

const loanHasRepaymentPlan = functionFrom(
  'loanHasRepaymentPlan',
  [] as const,
  TYPES.boolean,
  (ctx) => ctx.getLoanSnapshot().configuration.workoutPlans.length > 1, // TODO
  'Returns true if the loan snapshot shows an active repayment plan (stub logic).',
);

const loanHasForebearancePlan = functionFrom(
  'loanHasForebearancePlan',
  [] as const,
  TYPES.boolean,
  (_ctx) => false, // TODO
  'Returns true if the loan has an active forbearance plan (stub implementation).',
);

const loanHasNoPastDueStatements = functionFrom(
  'loanHasNoPastDueStatements',
  [] as const,
  TYPES.boolean,
  (_ctx) => false, // TODO
  'Returns true when no past-due billing statements exist for the loan (stub implementation).',
);

export const LOAN_FUNCTIONS = {
  [getFunctionSignature(loanHasPaymentDeferral)]: loanHasPaymentDeferral,
  [getFunctionSignature(loanHasRepaymentPlan)]: loanHasRepaymentPlan,
  [getFunctionSignature(loanHasForebearancePlan)]: loanHasForebearancePlan,
  [getFunctionSignature(loanHasNoPastDueStatements)]: loanHasNoPastDueStatements,
} satisfies FunctionLibrary;
